import { isStandalone, isIOS } from "@/lib/push"

/**
 * Capability seam for native-style back handling. This is the single place the
 * iOS-vs-Android branch lives.
 *
 * - Android-standalone: the hardware/gesture back fires `popstate`, so we can
 *   fully intercept it (sentinel + popstate) — double-back-to-exit, history
 *   flattening, overlay-close.
 * - iOS-standalone: the edge-swipe-back CANNOT be intercepted or cancelled, does
 *   NOT reliably fire `popstate` (WebKit bug 248303), and a PWA can't be closed
 *   from JS. So iOS gets "safe back": history is shaped (BottomNav replace
 *   discipline) so whatever back fires lands on Home, plus best-effort overlay
 *   close. On iOS 26.2+ the Navigation API can OBSERVE (never cancel) the back.
 */

/** Full History-sentinel interception is only reliable on Android-standalone. */
export function canInterceptBack(): boolean {
  return isStandalone() && !isIOS()
}

/** Safe-back history shaping runs on any installed PWA (Android + iOS). */
export function isSafeBackPlatform(): boolean {
  return isStandalone()
}

/**
 * Navigation API present (Android Chrome always; iOS 26.2+). Used only for
 * history-entry inspection and back OBSERVATION — never to cancel a traverse
 * (no browser allows that).
 */
export function hasNavigationApi(): boolean {
  return typeof window !== "undefined" && "navigation" in window
}
